import React, { useEffect, useState } from "react";

import Marquee from "react-fast-marquee";

// Image imports (using your provided path)
import logo01 from "../../images/brand/logo01.png";
import logo02 from "../../images/brand/logo02.png";
import logo03 from "../../images/brand/logo03.png";
import logo04 from "../../images/brand/logo04.png";
import logo05 from "../../images/brand/logo05.png";
import logo06 from "../../images/brand/logo06.png";

const brandLogos = [logo01, logo02, logo03, logo04, logo05, logo06];

const useCountUp = (target: number, duration: number) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    let start: number | null = null;
    let frameId: number;

    const step = (timestamp: number) => {
      if (start === null) {
        start = timestamp;
      }
      const progress = Math.min((timestamp - start) / duration, 1);
      setValue(Math.floor(progress * target));
      if (progress < 1) {
        frameId = requestAnimationFrame(step);
      }
    };

    frameId = requestAnimationFrame(step);

    return () => cancelAnimationFrame(frameId);
  }, [target, duration]);

  return value;
};

const formatNumber = (value: number) => {
  return value.toLocaleString("en-US");
};

const HeroSection: React.FC = () => {
  // Ajusta el segundo parámetro (duración en ms) para controlar la velocidad del conteo
  const totalSupply = useCountUp(600000000, 2600);
  const activeHolders = useCountUp(7500, 2600);
  const raisedPresale = useCountUp(13000000, 2600);
  const twitterFollowers = useCountUp(15000, 2600);

  return (
    <section className="hero hero-style hero--landing pos-rel bg_img">
      <div className="container">
        <div className="row">
          {/* ---------- Left Content ---------- */}
          <div className="col-lg-6 col-md-7">
            <div className="hero-content hero-content--landing">
              <h2 className="title scale-animation wow">
                Atom Foundation L3 Powered by Ethereum
              </h2>
              <p className="sub-title scale-animation wow">
                The First U.S.-Regulated Institutional Layer 3 on Ethereum
                Green Bitcoin Mining,  Legally Enforceable RWAs · 100k+ TPS ·
                Fully Insured & Bank-Grade
              </p>
              <div className="hero-btn scale-animation wow">
                {/* Botón blanco AUDIT (mismo estilo visual que Buy Presale del header) */}
                <a href="https://blocksafu.com/audit/0x85c9793Ac3e8328ddEE86590A015717D63C3d348" target="_blank" rel="noopener noreferrer" className="hero-audit-btn">
                  <span className="text">Audit</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="black"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="black"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="black"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="black"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="black"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="black"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                </a>

                <a
                  className="thm-btn agency-btn"
                  href="https://whitelist.atomfoundation.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text">Join Whitelist</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </div>

          {/* ---------- Right Globe Video (Vimeo) ---------- */}
          <div className="col-lg-6 col-md-5">
            <div className="hero-globe-wrapper wow zoomIn" data-wow-duration="800ms">
              {/*
                Ajustes principales del globo (video):
                - Para cambiar el tamaño general usa height y width en .hero-globe-iframe.
                - Para moverlo un poco a la izquierda/derecha o arriba/abajo,
                  modifica translateX / translateY en .hero-globe-position.
              */}
              <div className="hero-globe-position">
                <iframe
                  className="hero-globe-iframe"
                  src="https://player.vimeo.com/video/1140139866?muted=1&autoplay=1&autopause=0&controls=0&loop=1&app_id=122963"
                  title="Rotating planet"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                ></iframe>

                <div className="hero-stats-card">
                  <p className="hero-stats-title">Project</p>
                  <div className="hero-stats-list">
                    <div className="hero-stats-item">
                      <span className="hero-stats-label">Total Supply</span>
                      <span className="hero-stats-value">{formatNumber(totalSupply)}</span>
                    </div>
                    <div className="hero-stats-item">
                      <span className="hero-stats-label">Active holders</span>
                      <span className="hero-stats-value">{formatNumber(activeHolders)}+</span>
                    </div>
                    <div className="hero-stats-item">
                      <span className="hero-stats-label">Raised Whitelist</span>
                      <span className="hero-stats-value">${formatNumber(raisedPresale)}</span>
                    </div>
                    <div className="hero-stats-item">
                      <span className="hero-stats-label">Twitter followers</span>
                      <span className="hero-stats-value">{formatNumber(twitterFollowers)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- Brand Marquee inside Hero ---------- */}
      <div className="hero-brand-marquee">
        <Marquee speed={400} gradient={false} pauseOnHover={false} className="brand-marquee marquee-left">
          <div className="ac-brand-inner ul_li_between">
            {[...brandLogos, ...brandLogos, ...brandLogos].map((logo, index) => (
              <div className="xb-brand-item" key={index}>
                <img src={logo} alt={`brand-${index + 1}`} />
              </div>
            ))}
          </div>
        </Marquee>
      </div>
    </section>
  );
};

export default HeroSection;
